import { useCallback } from 'react';
import { useLanguage } from '../contexts/LanguageContext';

export const useLocalizedNavigation = () => {
  const { currentLanguage } = useLanguage();

  const getLocalizedPath = useCallback((path: string) => {
    const lang = currentLanguage || 'es';
    
    // Remove leading slash for easier matching
    const cleanPath = path.startsWith('/') ? path.slice(1) : path;
    
    // Handle root
    if (cleanPath === '') return `/${lang}`;

    // Handle properties
    if (cleanPath.startsWith('properties')) {
        const queryIndex = cleanPath.indexOf('?');
        const query = queryIndex !== -1 ? cleanPath.slice(queryIndex) : '';
        const base = lang === 'es' ? 'propiedades' : 'properties';
        return `/${lang}/${base}${query}`;
    }

    // Handle property detail
    if (cleanPath.startsWith('property/')) {
        const id = cleanPath.split('/')[1];
        const base = lang === 'es' ? 'propiedad' : 'property';
        return `/${lang}/${base}/${id}`;
    }

    // Handle agent detail
    if (cleanPath.startsWith('agent/')) {
        const id = cleanPath.split('/')[1];
        const base = lang === 'es' ? 'agente' : 'agent';
        return `/${lang}/${base}/${id}`;
    }

    // Handle saved
    if (cleanPath.startsWith('saved')) {
        const base = lang === 'es' ? 'guardadas' : 'saved';
        return `/${lang}/${base}`;
    }
    
    // Handle about
    if (cleanPath === 'acerca-de' || cleanPath === 'about') {
        const base = lang === 'es' ? 'acerca-de' : 'about';
        return `/${lang}/${base}`;
    }

    // Handle careers
    if (cleanPath === 'trabajos' || cleanPath === 'careers') {
        const base = lang === 'es' ? 'trabajos' : 'careers';
        return `/${lang}/${base}`;
    }

    // Handle help
    if (cleanPath === 'ayuda' || cleanPath === 'help') {
        const base = lang === 'es' ? 'ayuda' : 'help';
        return `/${lang}/${base}`;
    }

    // Handle other known routes
    if (['login', 'signup', 'cookies', 'legal'].includes(cleanPath)) {
        return `/${lang}/${cleanPath}`;
    }

    // Default fallback: just prefix
    return `/${lang}/${cleanPath}`;
  }, [currentLanguage]);

  return { getLocalizedPath };
};
